import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { taskStatusByCode } from 'entities';

import { Button } from 'components/Blocks';

import { useProject } from 'providers/Project';
import { useUser } from 'hooks/user';

import { UserOwnershipBreakdown } from '../components';

import { truncateText } from 'utils/text';
import { resolveColorClass } from 'styles';

export function TeamTasks() {
  const { t } = useLang();
  const user = useUser();

  const { projectList, projects } = useProject();

  const teamTasks = useMemo(() => {
    return projectList
      .map(({ tasks }) =>
        tasks.filter(
          ({ team, status }) => taskStatusByCode[status].isActiveStatus && team === user.team.id,
        ),
      )
      .flat();
  }, [projectList, user]);

  return (
    <UserOwnershipBreakdown
      title={t('active-tasks-per-user')!}
      statusConfig={taskStatusByCode}
      entries={teamTasks}
      render={(task) => (
        <Button
          variant="ghost"
          to="projectProfile"
          params={task}
          linkTarget={task.projectId}
          tooltipContent={`${task.name} (${projects[task.projectId]?.name})`}
          className={resolveColorClass(taskStatusByCode[task.status].color, 'text')}
        >
          {truncateText(`${task.name} (${projects[task.projectId]?.name})`, 35)}
        </Button>
      )}
    />
  );
}
